export default __webpack_public_path__ + "static/media/formBGforOmega.88299c67.png";